import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevantempo() {



const cardData =
{
  keyword: '17 Seater Tempo Traveller for Konkan Darshan',
  heading: 'Sanavi Travels: 17 Seater Tempo Traveller for Konkan Darshan',
  headingDescription: 'Sanavi Travels offers reliable and comfortable 17 Seater Tempo Traveller services for Konkan Darshan, ideal for families, groups, corporate teams, and pilgrims planning scenic coastal journeys across the Konkan region with safety, convenience, and professional travel management.',

  top: 'Top Konkan Darshan Experiences with 17 Seater Tempo Traveller',

  topPlaces: [
    {
      title: 'Scenic Konkan Coastal Route',
      description: 'Konkan Darshan is famous for its breathtaking coastal highways, lush green hills, rivers, and Arabian Sea views. Traveling in a 17 seater Tempo Traveller allows the entire group to enjoy these scenic stretches together without splitting into multiple vehicles. The elevated seating and large windows offer panoramic views, making the journey as memorable as the destination itself. Group travel ensures better coordination, shared experiences, and stress-free navigation through winding coastal roads.'
    },
    {
      title: 'Ganpatipule Temple & Beach',
      description: 'Ganpatipule is one of the most revered and picturesque destinations in Konkan. A 17 seater Tempo Traveller is ideal for family and group darshan trips, offering ample space for passengers and luggage. The comfortable seating helps travelers remain relaxed during long drives, while experienced drivers manage ghat sections and coastal routes safely. Group travel ensures timely darshan and easy movement between temple visits and beach exploration.'
    },
    {
      title: 'Tarkarli & Malvan Beaches',
      description: 'Tarkarli and Malvan are popular for pristine beaches, water sports, and coastal cuisine. Traveling together in a Tempo Traveller allows groups to carry beach gear, personal luggage, and food supplies conveniently. The spacious interior ensures comfort after long sightseeing days, making it ideal for multi-day Konkan tours.'
    },
    {
      title: 'Sindhudurg Fort Exploration',
      description: 'Sindhudurg Fort visits often involve ferry points and tight schedules. A dedicated Tempo Traveller ensures punctual arrival and organized group movement. It eliminates confusion caused by multiple vehicles and enhances overall travel efficiency.'
    },
    {
      title: 'Harihareshwar & Shrivardhan Darshan',
      description: 'These spiritual and beach destinations are best explored as part of a group tour. A 17 seater Tempo Traveller offers smooth long-distance travel, comfortable overnight journeys, and sufficient luggage space for extended stays.'
    },
    {
      title: 'Group Bonding During Long Journeys',
      description: 'Konkan tours involve long travel hours. Group travel in a Tempo Traveller encourages interaction, bonding, music, and shared experiences, turning travel time into quality group moments.'
    },
    {
      title: 'Comfort Through Ghats & Coastal Roads',
      description: 'Konkan routes include ghats, curves, and narrow roads. Tempo Travellers are designed for stability, comfort, and safety, reducing fatigue for passengers during long drives.'
    },
    {
      title: 'Flexible Multi-Destination Itineraries',
      description: 'Konkan Darshan often covers multiple destinations over several days. Tempo Traveller rentals support flexible routes, night halts, and customized plans without logistical stress.'
    },
    {
      title: 'Luggage & Essentials Management',
      description: 'Large luggage space makes it easy to carry personal bags, food supplies, temple offerings, and beach accessories without overcrowding passenger seating.'
    },
    {
      title: 'Cost-Effective Group Travel',
      description: 'Hiring a single 17 seater Tempo Traveller is more economical than multiple cars, reducing fuel, toll, and coordination costs while simplifying trip management.'
    }
  ],

  services: [
    {
      name: '17 Seater Tempo Traveller for Konkan Darshan',
      description: 'Sanavi Travels provides premium 17 seater Tempo Traveller services for Konkan Darshan, designed for long-distance comfort, safety, and group coordination. This service is ideal for families, pilgrim groups, corporate outings, and leisure travelers exploring Konkan beaches, temples, and heritage sites. With spacious seating, experienced drivers, and reliable vehicles, travelers can enjoy a smooth and memorable Konkan journey.'
    },
    {
      name: 'AC 17 Seater Tempo Traveller Konkan',
      description: 'AC Tempo Travellers ensure comfortable travel during humid coastal weather, keeping passengers relaxed throughout long journeys.'
    },
    {
      name: 'Non AC 17 Seater Tempo Traveller Konkan',
      description: 'Non-AC options offer budget-friendly solutions while maintaining comfort and safety for group travel.'
    },
    {
      name: 'Luxury 17 Seater Tempo Traveller Konkan',
      description: 'Luxury variants provide premium interiors, push-back seating, and enhanced ride comfort for high-end group tours.'
    },
    {
      name: 'Tempo Traveller for Family Konkan',
      description: 'Family-friendly services ensure safe and comfortable travel for elders and children during Konkan Darshan.'
    },
    {
      name: 'Tempo Traveller for Corporate Konkan',
      description: 'Corporate Konkan tours benefit from punctual service, professional drivers, and organized group travel.'
    },
    {
      name: 'Tempo Traveller for Group Konkan',
      description: 'Group travel services ensure all members travel together, improving coordination and shared experiences.'
    },
    {
      name: 'Affordable 17 Seater Tempo Traveller Konkan',
      description: 'Affordable pricing with transparent cost structures helps groups manage tour budgets efficiently.'
    },
    {
      name: 'Best Tempo Traveller Service Konkan',
      description: 'Sanavi Travels is known for reliability, vehicle cleanliness, and professional service across Konkan routes.'
    },
    {
      name: 'Tempo Traveller with Driver Konkan',
      description: 'Experienced drivers familiar with Konkan roads, ghats, and destinations ensure safe and timely travel.'
    },
    {
      name: 'Tempo Traveller for Wedding Konkan',
      description: 'Wedding groups traveling to Konkan destinations benefit from organized and comfortable group transport.'
    },
    {
      name: 'Tempo Traveller for Picnic Konkan',
      description: 'Ideal for beach picnics, weekend trips, and leisure tours with friends or family.'
    },
    {
      name: 'Mini Bus on Rent Konkan',
      description: 'Mini bus options are available for larger groups requiring additional seating capacity.'
    },
    {
      name: '17 Seater Tempo Traveller for Sightseeing Konkan',
      description: 'Perfect for sightseeing tours covering beaches, temples, forts, and scenic viewpoints.'
    },
    {
      name: 'Tempo Traveller for Outstation Konkan',
      description: 'Reliable outstation services support multi-day Konkan Darshan itineraries.'
    }
  ],

  tableData: [
    ['AC 17 Seater', 'Non AC 17 Seater'],
    ['Luxury Variant', 'Standard Variant'],
    ['Family Tours', 'Corporate Tours'],
    ['Picnic Trips', 'Pilgrimage Tours'],
    ['Affordable Pricing', 'Professional Drivers']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Konkan Travel Expertise',
      WhyChoosedescription: 'Experienced handling of Konkan routes, ghats, and coastal travel requirements.'
    },
    {
      WhyChooseheading: 'Comfortable Group Vehicles',
      WhyChoosedescription: 'Spacious seating and smooth suspension ensure relaxed long-distance travel.'
    },
    {
      WhyChooseheading: 'Professional Drivers',
      WhyChoosedescription: 'Drivers trained for long routes and coastal driving conditions.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear cost structure without hidden charges.'
    },
    {
      WhyChooseheading: 'Flexible Tour Planning',
      WhyChoosedescription: 'Customizable itineraries, stops, and schedules.'
    },
    {
      WhyChooseheading: 'Safe & Reliable Service',
      WhyChoosedescription: 'Well-maintained vehicles and safety-focused operations.'
    },
    {
      WhyChooseheading: 'Ideal for Group Travel',
      WhyChoosedescription: 'Ensures everyone travels together comfortably.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Assistance available throughout the Konkan journey.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide 17 seater Tempo Traveller for Konkan Darshan?',
    answer: 'Yes, Sanavi Travels offers dedicated 17 seater Tempo Traveller services for Konkan Darshan tours.'
  },
  {
    question: 'Are AC Tempo Travellers available?',
    answer: 'Yes, both AC and Non-AC options are available.'
  },
  {
    question: 'Is this suitable for family Konkan tours?',
    answer: 'Yes, it is ideal for family and group travel.'
  },
  {
    question: 'Are drivers experienced with Konkan routes?',
    answer: 'Yes, drivers are familiar with coastal roads and ghats.'
  },
  {
    question: 'Can the itinerary be customized?',
    answer: 'Yes, routes and stops can be customized.'
  },
  {
    question: 'Is luggage space sufficient?',
    answer: 'Yes, ample luggage space is provided.'
  },
  {
    question: 'Is this service cost-effective?',
    answer: 'Yes, it is economical for group travel.'
  },
  {
    question: 'Is advance booking required?',
    answer: 'Advance booking is recommended during peak seasons.'
  },
  {
    question: 'Are vehicles sanitized?',
    answer: 'Yes, vehicles are cleaned before every trip.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 support is available.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajit Kulkarni',
    feedback: 'Our Konkan Darshan trip in a 17 seater Tempo Traveller from Sanavi Travels was extremely comfortable. The driver was experienced, and the vehicle handled long coastal routes smoothly. Highly recommended for group tours.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Deshpande',
    feedback: 'We traveled with family to Ganpatipule and Tarkarli using Sanavi Travels. The Tempo Traveller was spacious, clean, and perfect for our Konkan tour. Great service and coordination.',
    rating: 5
  }
];







































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Tempo Traveller for Konkan Darshan - Sanavi Travels",
  "description": "Sanavi Travels offers 17 seater Tempo Traveller services for Konkan Darshan. Choose AC or Non-AC options, luxury variants, or hire for family trips, corporate travel, group tours, weddings, picnics, sightseeing, and outstation journeys with a professional driver.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 17 Seater Tempo Traveller for Konkan Darshan | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 17 seater Tempo Traveller for Konkan Darshan with Sanavi Travels. AC, Non AC, luxury Tempo Traveller options for family, corporate, group trips, weddings, picnics, sightseeing, and outstation travel with driver at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/308.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevantempo;